<template>
  <div class="point-viewer">
    <AppMapPointPanelHeader :header="header" @close="$emit('close')" />
    <div class="point-viewer__content">
      <AppMapPointPanelFirstRow @edit="edit" :id="point.id" :img="avatarSrc" :has-edit="can(PN.POINT_UPDATE)" :has-preview="false" />
      <table class="table user-view-table m-0">
        <tbody>
          <tr v-if="point.title">
            <th>Name:</th>
            <td>{{ point.title }}</td>
          </tr>
          <tr v-if="point.reference_id">
            <th>Reference ID:</th>
            <td>{{ point.reference_id }}</td>
          </tr>
          <tr v-if="point.url">
            <th>Link:</th>
            <td>
              <a :href="point.url" target="_blank">{{ point.url }}</a>
            </td>
          </tr>
          <tr v-if="point.description">
            <th>Note:</th>
            <td class="multiline">{{ point.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as PN from '@/utils/PermissionNames'
import { getAvatarSrc } from '@/utils/Helpers'
import { getIconUrl } from '@/components/leaflet/Icon'
import AppMapPointPanelHeader from '@/components/shared/AppMapPointPanelHeader.vue'
import { getItemHeader } from '@/components/shared/helpers'
import AppMapPointPanelFirstRow from '@/components/shared/AppMapPointPanelFirstRow.vue'

/**
 * Display extra point types like firstAid and so on
 */
export default {
  name: 'PointViewer',
  components: { AppMapPointPanelFirstRow, AppMapPointPanelHeader },
  data: () => ({
    PN,
    printerTemp: {}
  }),
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    ...mapGetters('point', ['getPoint']),
    ...mapGetters('pointIcon', ['getPointIcon']),
    ...mapGetters('rbac', ['can']),
    header() {
      return getItemHeader(this.point, 'Point')
    },
    point() {
      return this.getPoint(this.id) || {}
    },
    pointIcon() {
      return this.getPointIcon(this.point.icon_id)
    },
    avatarSrc() {
      const defaultSrc = getIconUrl(this.pointIcon.id, this.pointIcon.file_updated_at)
      return getAvatarSrc('', '', defaultSrc)
    }
  },
  methods: {
    edit() {
      this.$emit('edit')
    }
  }
}
</script>

<style>
.point-viewer__content {
  padding: 24px;
}
</style>
